import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Image } from "primereact/image";
import { useToast } from "../other/Toast";
import { useCallback, useRef, useState } from "react";
import Webcam from "react-webcam";
import fileUploadService from "../service/fileUploadService";

function captureVideo(progressCallback) {
    return new Promise((resolve, reject) => {
        var canvas = document.getElementById("video-capture-comp");

        // Optional frames per second argument.
        var stream = canvas.captureStream(25);
        var recordedChunks = [];

        var options = { mimeType: "video/webm; codecs=vp9" };
        const mediaRecorder = new MediaRecorder(stream, options);

        mediaRecorder.ondataavailable = handleDataAvailable;
        mediaRecorder.start();

        function handleDataAvailable(event) {
            console.log("data-available");
            if (event.data.size > 0) {
                recordedChunks.push(event.data);
                console.log(recordedChunks);
                download();
            } else {
                // ...
            }
        }
        function download() {
            var blob = new Blob(recordedChunks, {
                type: "video/webm"
            });
            console.log('video: ', blob);

            resolve(blob);
            // var url = URL.createObjectURL(blob);
            // var a = document.createElement("a");
            // document.body.appendChild(a);
            // a.style = "display: none";
            // a.href = url;
            // a.download = "test.webm";
            // a.click();
            // window.URL.revokeObjectURL(url);
        }

        // demo: to download after 9sec

        let count = 5;
        progressCallback(count);
        const progrssNotifier = setInterval(event => {
            progressCallback(count--);
        }, 1000);

        setTimeout(event => {
            clearInterval(progrssNotifier);
            console.log("stopping");
            mediaRecorder.stop();
        }, 5000);
    });
}

const videoConstraints = {
    width: 206,
    height: 258,
    facingMode: "user"
};

export async function getBlob(base64) {
    return await (await fetch(base64)).blob();
}

const CaptureImage = ({ visible, onHide, onUpload, docType }) => {
    const webcamRef = useRef(null);
    const toast = useToast();
    const [image, setImage] = useState();
    const [video, setVideo] = useState();
    const [videoCaptureCount, setVideoCaptureCount] = useState(0);

    const capture = useCallback(
        () => {
            const imageSrc = webcamRef.current.getScreenshot();
            setImage(imageSrc);
            console.log(imageSrc);
        },
        [webcamRef]
    );

    const uploadVideo = () => {
        if (video)
            fileUploadService.uploadFile(video, 'capture_video.wmb')
                .then(r => {
                    toast.success("Successful " + "File Upload Success");
                    onUpload(r.data);
                    setVideo(null);
                    onHide();
                }).catch(e => {
                    toast.error("Error Message", "File Uplaod Failed");
                })
    }

    const uploadImage = () => {
        onHide(false);
        if (image) {
            getBlob(image).then(img => {
                fileUploadService.uploadFile(img, "capture.jpg")
                    .then(r => {
                        toast.success("Successful " + "File Upload Success");
                        onUpload(r.data);
                        setImage(null);
                        onHide();
                    }).catch(e => {
                        toast.error("Error Message", "File Uplaod Failed");
                    })
            })
        }
    };

    return (<>

        <Dialog
            header="Webcam"
            visible={visible}
            style={{}}
            onHide={onHide} >
            {image ? <Image src={image} /> : <div id="video-capture-div" style={{ width: 208, height: 258 }} ><Webcam
                id="video-capture-comp"
                audio={false}
                ref={webcamRef}
                screenshotFormat="image/jpeg"
                videoConstraints={videoConstraints}
            /></div>}<br />
            <div className="col-md-12" style={{ display: 'flex', justifyContent: 'space-around', }}>
                {docType === 'I' && <>
                    {image
                        ? <Button onClick={uploadImage} label="Upload" />
                        : <Button onClick={capture} label="Capture photo" />}
                </>}
                {docType === 'V' && <>{video ? <Button onClick={uploadVideo} label="Upload" /> : !videoCaptureCount && <Button onClick={() => captureVideo(setVideoCaptureCount).then((v) => { setVideo(v); setVideoCaptureCount(null) })} label="Capture Video" />}
                    {!!videoCaptureCount && <p style={{ fontSize: 30 }}>{videoCaptureCount}</p>}</>}
                {!videoCaptureCount && ((docType === 'I' && image) || (docType === 'V' && video)) && <Button className="p-button-secondary" style={{ float: 'right' }} onClick={() => {
                    setImage(null);
                    setVideo(null);
                    setVideoCaptureCount(null);
                }} label="Reset" />}
            </div>
        </Dialog></>);
};

export default CaptureImage;